import Modernizr from 'modernizr';
import Masonry from 'masonry-layout';

export default function(){
	console.debug('wom init called');
	console.debug('Modernizr' + Modernizr);

	setHelperBox();
	setBigViewBackgroundImages();
	setBigViewImage();
	setSliderTeaser2Height();
	
	
	if (Modernizr.touchevents) {
		$('.oldItemContainer.news, .oldItemContainer.profile').on('click',function(){
			$(this).find('.arrowTop,.oldSecondContainer').toggle();
		})
		
		// show menu on comments
		$('.oldCommentContainer .oldMenuContainer>div.icon').show();
		$('.oldCommentContainer .oldMenuContainer').on('click',function(){
			$(this).find('.arrowTop, .oldEditMenuContainer').toggle();
		})
		
		//show menu on userContentOverview and Detail
		//$('.oldUserContent .oldNaviDots').on('click',function(){
		//	$(this).find('.arrowTop, .oldEditMenuContainer').toggle();
		//})
		
	} else {
		$('.oldItemContainer.news, .oldItemContainer.profile').on('mouseenter mouseleave',function(){
			$(this).find('.arrowTop,.oldSecondContainer').toggle();
		})
		
		//icon at comments
		//$('.oldCommentContainer .oldMenuContainer>div.icon').show();
		
		$('.oldCommentContainer').on('mouseenter mouseleave',function(){
			$(this).find('.oldMenuContainer>div.icon').toggle();
		})		
		$('.oldCommentContainer .oldMenuContainer').on('mouseenter mouseleave',function(){
			$(this).find('.arrowTop, .oldEditMenuContainer').toggle();
		})

		//show menu on userContentOverview and Detail
		//$('.oldUserContent .oldNaviDots').on('mouseenter mouseleave',function(){
		//	$(this).find('.arrowTop, .oldEditMenuContainer').toggle();
		//})

	}
	
	$('.oldItemContainer').each(function(){
		$(this).find('.arrowTop').width($(this).width());
	})

	
	$('#toggleHelper').on('click',function(){toggleHelper()});
	
	$('#smallNaviSelect').change(function() {
		changeProjectPage(this.value);
	});

	//check if teaser advertisement (addAdvToFooter) is available then add class to footer
	if($('.addAdvToFooter').length > 0) $('footer').addClass('adv');
	
	//start carousel
	$('.carousel').not('#oldTopTeaser.carousel').carousel({
		  interval: false
	});
	
	$('#oldTopTeaser.carousel').carousel({
		interval:false //später diese Zeile löschen
//		interval: 5000 //später aktivieren für den TopTeaser auf der home
	})
	
	//hover effect on profile picture
	$('.profile .roundImageOrigin, .profileBoxWithPictureSmall .roundImageOrigin').hover(
			  function() {
				    $( this ).find('.blackHover').show();
				  }, function() {
					  $( this ).find('.blackHover').hide();
				  }
	);

	$('.public.label-item a').on('click',function(){
		var container = $(this).parent().parent();
		container.toggleClass('compact');
		container.toggleClass('extended');
		$(this).next().toggle();
		return false;
	});
	
	/*
	var elem = document.querySelector('.grid');
	var msnry = new Masonry( elem, {
	  // options
	  itemSelector: '.grid-item',
	  columnWidth: '.grid-item',
	  percentPosition: true
	});
	*/
	
	
	arrangePinboardElements();
	
	  
	  //bind tabs
	  $('.oldTabOuterContainer').each(function(){
		  var _tabOuterContainer = $(this);
		  
		  $(_tabOuterContainer).find('.tabEntry').on('click',function(){
			  $(_tabOuterContainer).find('.tabEntry').removeClass('active');
			  $(this).addClass('active');
			  $(this).closest('.border-color1').find('.tabContent').hide();
			  $('#'+$(this).attr('data-container')).show();
		  })
	  })
}

$(window).resize(function(){
	setHelperBox();
	setBigViewBackgroundImages();
	setBigViewImage();
	resetSidebar();
	setSliderTeaser2Height();
})
function resetSidebar() {
  if($('#navSidebar').hasClass('visible')) {
    $('#navSidebar').toggleClass('visible');
    $('#fadeContent').toggleClass('visible');
    $('body').toggleClass('noscroll');
  }
}

function initInterfaceElements(){
	// Toggle Sidebar Menu
	$('.menuIcon').click(function(event) {
	    event.preventDefault();
	    $('#navSidebar').toggleClass('visible');
	    $('#fadeContent').toggleClass('visible');
	    $('body').toggleClass('noscroll');
	});
	$('#fadeContent').click(function(event) {
	    event.preventDefault();
	    $('#navSidebar').toggleClass('visible');
	    $('#fadeContent').toggleClass('visible');
	    $('body').toggleClass('noscroll');
	});
	$('.closeIcon').click(function(event) {
	    event.preventDefault();
	    $('#navSidebar').toggleClass('visible');
	    $('#fadeContent').toggleClass('visible');
	    $('body').toggleClass('noscroll');
	});
}

function setSliderTeaser2Height(){
	var maxHeight = 0;
	$('.teaserSlider2').each(function(){
		$('.carousel-item').each(function(){
			var carouselItemHeight = $(this).outerHeight();
			if (carouselItemHeight > maxHeight) {
				maxHeight = carouselItemHeight;
			}
		})
		$(this).css('height', maxHeight);
	})
	
}

//get actual View xs, sm, md, lg, xl
function getActualView(){
	return $('#viewIndicator').find('div:visible').attr('id').substring(0,2);
}

function setBigViewBackgroundImages(){
	var image;
	var height;
	var data;
	var separator = '----';
	$('.oldBigView').each(function(){
		//console.log(getActualView());
		data = $(this).attr('data-'+getActualView());
		image = data.split(separator)[0];
		height = data.split(separator)[1];
		
		$(this).css({'background-image':'url('+image+')','height':height+'px'})
		
		//if a carousel is inside
		if($(this).find('.carousel-item').length > 0) $(this).find('.carousel-item').css('min-height',height+'px'); 
	})
	
}

function setBigViewImage(){
	var imageSrc;
	$('.oldBigViewImage').each(function(){
		//console.log(getActualView());
		imageSrc = $(this).attr('data-'+getActualView());
		if(imageSrc == undefined) imageSrc = $(this).attr('data-xl');
		
		$(this).attr('src',imageSrc);
		
	})
	
}

//could delete later
//box at the bottom
function setHelperBox(){
	
	$('#foo1').html($('#foo1').parent().width());
	$('#foo2').html($('#foo2').parent().outerWidth());
	
	$('#helper').html($("body").prop("scrollWidth") + " (Viewport)" + " - " + window.outerWidth);
	
	/*if(
			(window.outerWidth >= 575 && window.outerWidth <= 577) ||
			(window.outerWidth >= 767 && window.outerWidth <= 769) ||
			(window.outerWidth >= 991 && window.outerWidth <= 993) ||
			(window.outerWidth >= 1199 && window.outerWidth <= 1201)
	
	){
		$('#helperContainer').addClass('alert');
	}else{
		$('#helperContainer').removeClass('alert');
	}*/
}

function toggleHelper(){
	$('#helperContainer').toggleClass('helperHeight');
}

function changeProjectPage(url){
	window.location.href = url;
}

var arrangedPinboardElements = false;

export function arrangePinboardElements() {
	if(arrangedPinboardElements) {
		return; 
	}
	var elements = document.getElementsByClassName('grid');
	var msnry;

	  // init Isotope after all images have loaded
	  var n = elements.length;
	  for(var i = 0; i < n; i++){
	    msnry = new Masonry( elements[i], {
	    	itemSelector: '.grid-item',
		  	  columnWidth: '.grid-item',
		  	  percentPosition: true
		});
	  }
	  if(n > 0) {
		  arrangedPinboardElements = true;
	  }
}
$(document).ready(function(){
  initInterfaceElements();
  controlNaviSmall();
});

var maxScrollDistance = 100;
var maxScrollDistance = Math.min(maxScrollDistance, $(window).height());

function controlNavbarLogo() {
	var  showNavLogo;
  	var scrollTopPos = Math.min($(document).scrollTop(), maxScrollDistance);
  	if (scrollTopPos >= maxScrollDistance) { 
		showNavLogo = true; 
	} else { 
		showNavLogo = false; 
	}
  	$('#navDesktop').toggleClass('stickyFix', showNavLogo); // Fix for Browsers not supporting position: sticky
}

var naviSmallElement = $('.project').find('.naviSmall');

function controlNaviSmall() {
	var maxScrollDistanceNaviSmall = $('.projectLogo').height() + 40;
	if ($('.sliderTeaser2').length > 0) {
		maxScrollDistanceNaviSmall =+ $('.sliderTeaser2').outerHeight(true);
	}
	var maxScrollDistanceNaviSmall = Math.min(maxScrollDistanceNaviSmall, $(window).height());
	var  showNaviSmall;
  	var scrollTopPos = Math.min($(document).scrollTop(), maxScrollDistanceNaviSmall);
  	if (scrollTopPos >= maxScrollDistanceNaviSmall) { 
		showNaviSmall = true; 
	} else { 
		showNaviSmall = false; 
	}
  	naviSmallElement.toggleClass('stickyNaviSmall', showNaviSmall); // Fix for Browsers not supporting position: sticky
}

$(window).scroll(function() {
	if (window.matchMedia('(min-width: 768px)').matches) {
		controlNavbarLogo();
	}
	if (window.matchMedia('(max-width: 992px)').matches) {
		controlNaviSmall();
	}
});


// WEBPACK FOOTER //
// ./src/js/wom.js